import { Entity } from '../models/entity.model';
import { Property, PropertyItem } from '../models/property.model';

// converts the json formatted entity list returned from Hood3DModelController to the format used in angular entity state
// without this, angular state management won't be able read entity properties
export const convertFormattedEntities = (entities: Entity[]) => {
  return entities.map(entity => {
    const properties = {};

    Object.keys(entity.Properties).forEach(key => {
      const property = entity.Properties[key];

      property.Items = property.Items['$values'] as PropertyItem[];

      properties[property.Key] = property;
    });

    return {
      ...entity,
      Properties: properties as Record<string, Property>
    } as Entity;
  });
};

export const convertKeysToPascalCase = data => {
  if (Array.isArray(data)) {
    // Process each element in the array
    return data.map(item => convertKeysToPascalCase(item));
  } else if (data !== null && typeof data === 'object') {
    // Process each key in the object
    return Object.keys(data).reduce((acc, key) => {
      const pascalKey = camelToPascal(key);
      acc[pascalKey] = convertKeysToPascalCase(data[key]);
      return acc;
    }, {});
  }
  // Primitive value (string, number, boolean, null, etc.)
  return data;
};

const camelToPascal = (str: string) => {
  if (typeof str !== 'string' || str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
